<template>
  <v-app class="center">
    <Header v-if="this.$store.state.usuario.usuario == null"></Header>
    <HeaderLogged
      :key="$route.fullPath"
      v-if="this.$store.state.usuario.usuario != null"
    ></HeaderLogged>
    <transition name="slide">
      <router-view></router-view>
    </transition>
  </v-app>
</template>
<script lang="js">
import Header from "./components/Headers/Header.vue";
import HeaderLogged from "./components/Headers/HeaderLogged.vue";
import axios from "@/axios-auth"

export default {
  name: "App",
  data() {
    return {
      notificationInterval: null,
    };
  },
  methods: {
     async fetchNotifications() {
      try {
        const params = {
          idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          usuario: this.$store.state.usuario.usuario.toString().trim(),
        };
        const { data: listaRecordatorios } = await axios.get(
          "/Usuario/CargarRecordatorios?",
          {
            params,
          }
        );

        if (listaRecordatorios) {
          const listaRecordatoriosNotificacion = listaRecordatorios.filter(
            (item) => item.notifica
          );
          this.$store.dispatch(
            "setListaRecordatorios",
            listaRecordatoriosNotificacion
          );
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    },
  },
  mounted() {
    this.notificationInterval = setInterval(() => {
      if (
        this.$store.state.usuario.usuario !== null &&
        this.$store.state.usuario.institucion.idInstitucion !== null
      ) {
        this.fetchNotifications();
      }
    }, 5 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.notificationInterval);
  },
  components: {
    Header,
    HeaderLogged,
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.center {
  display: flex;
  align-items: center;
}
.slide-enter {
  opacity: 0;
}

.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
  transition: 0.5s;
}

.slide-move {
  transition: transform 1s;
}
.slide-leave-active {
  animation: slide-out 1s ease-out forwards;
  transition: opacity 1s;
  opacity: 0;
  position: absolute;
}

@keyframes slide-in {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(20px);
  }
}

.v-card__actions {
  flex-wrap: wrap;
  gap: 1rem;
}
.v-data-table__mobile-table-row {
  padding-top: 1rem;
  td {
    padding-bottom: 0.5rem !important;
  }
  td:last-child {
    padding-bottom: 1rem !important;
  }
}

</style>
